module.exports = __webpack_public_path__ + "static/media/hubspotlogo-web-white.e6794ae3.svg";